/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useForgotPassword } from '../use-forgotPassword';
import Grid from '@mui/material/Grid';
import { useTranslate } from '@im/react-localization';
import { Link, useNavigate } from 'react-router-dom';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import Tooltip from '@mui/material/Tooltip';
import AlertBox from './AlertBox';

export const ForgotPassword = () => {
  //Translate parameter
  const translate = useTranslate();
  const navigate = useNavigate();
  const [hideinitialHeader, setHideinitialHeader] = useState(false);
  const [hideEmail, setHideEmail] = useState(false);
  const [hideUserName, setHideUserName] = useState(false);
  const [hidesubmit, setHidesubmit] = useState(false);
  const [hideLogin, setHideLogin] = useState(true);
  const [successMessage, setSuccessMessage] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [disaledUser, setDisaledUser] = useState(false);
  const [userAccountLocked, setAccountLocked] = useState(false);
  const [userName, setUserName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');

  const forgotPassword = useForgotPassword();
  // eslint-disable-next-line no-useless-escape
  const validEmail = /^([\w\.\-+]+)@([\w\-]+)((\.(\w)+))*((\.(\w){2,})+)$/;
  const [emailError, setEmailError] = useState(false);
  const [userNameError, setUserNameError] = useState(false);
  const [stateTooltip, setStateTooltip] = useState(false);
  const [SuccessAlert, setSuccessAlert] = useState({
    messageKey: '',
    showAlert: false,
  });
  let error = null;
  if (
    emailError === true &&
    userNameError === true &&
    disaledUser === false &&
    userAccountLocked === false
  ) {
    error = 'AccMgmt.ForgotPassword_UnableToIdentifyErrorMeesage';
  } else if (
    disaledUser === true &&
    emailError === false &&
    userNameError === false &&
    userAccountLocked === false
  ) {
    error = 'AccMgmt.ForgotPassword_DisableErrorMeesage';
  } else if (
    userAccountLocked === true &&
    disaledUser === false &&
    emailError === false &&
    userNameError === false
  ) {
    error = 'AccMgmt.ForgotPassword_LockedErrorMeesage';
  } else {
    error = 'AccMgmt.Forgotpassword_Initialheading';
  }
  //email validation function
  const emailValidator = (emailAddress: any) => {
    const isValidEmail = validEmail.test(emailAddress);
    if (isValidEmail) {
      setEmailError(false);
    } else if (!isValidEmail && emailAddress !== '') {
      setEmailError(true);
    }
    return isValidEmail;
  };
  const handleChange =
    (prop: string) => (event: { target: { value: any } }) => {
      setUserNameError(false);
      setEmailError(false);
      setDisaledUser(false);
      setAccountLocked(false);
      if (prop === 'email') {
        setEmailAddress(event.target.value);
      }
      if (prop === 'username') {
        setUserName(event.target.value);
      }
      if (emailAddress === '' || userName === '') {
        setDisableSubmit(true);
      } else {
        emailValidator(emailAddress);
        setDisableSubmit(false);
        if (!emailError) {
          setStateTooltip(false);
        }
      }
    };
  useEffect(() => {
    if (emailAddress === '' || userName === '') {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
    const li = document.querySelector('.css-lfi3fm');
    li?.setAttribute('style', 'padding: 0');
  }, [emailAddress, userName]);
  const UpdateChangePassword = () => {
    const body = {
      EmailAddress: emailAddress,
      UserName: userName,
    };
    const emailValid = emailValidator(emailAddress);
    if (emailValid && emailAddress !== '') {
      setStateTooltip(false);
      forgotPassword.mutate(body, {
        onError: (error: any) => {
          let parsedError = null;
          let errorMessage = null;
          if (error instanceof Error) {
            parsedError = JSON.parse(error.message);
            errorMessage = parsedError.errors[0].message;
          }
          if (
            errorMessage ===
            'Your account is disabled.For more information, please contact your company administrator.'
          ) {
            setSuccessAlert({
              messageKey: 'AccMgmt.ForgotPassword_DisableErrorMeesage',
              showAlert: false,
            });
            setDisaledUser(true);
          } else if (
            errorMessage ===
            "We're sorry. We were unable to identify you. Please try again."
          ) {
            setSuccessAlert({
              messageKey: 'AccMgmt.ForgotPassword_UnableToIdentifyErrorMeesage',
              showAlert: false,
            });
            setEmailError(true);
            setUserNameError(true);
          } else if (
            errorMessage ===
            'Your account is locked, please contact your company administrator or retry in 20 minutes.'
          ) {
            setSuccessAlert({
              messageKey: 'AccMgmt.ForgotPassword_LockedErrorMeesage',
              showAlert: false,
            });
            setAccountLocked(true);
          }

          setSuccessMessage(false);
          setHideLogin(true);
          setHideEmail(false);
          setHideUserName(false);
          setHidesubmit(false);
          setHideinitialHeader(false);
        },
        onSuccess: () => {
          setHideEmail(true);
          setHideUserName(true);
          setHidesubmit(true);
          setHideLogin(false);
          setSuccessMessage(true);
          setHideinitialHeader(true);
          setEmailError(false);
          setStateTooltip(false);
          setSuccessAlert({
            messageKey: '',
            showAlert: false,
          });
        },
      });
    } else {
      setStateTooltip(true);
    }
  };

  return (
    <>
      <Box>
        {' '}
        {SuccessAlert.showAlert && (
          <AlertBox alert={SuccessAlert} setalert={setSuccessAlert} />
        )}
      </Box>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: '0 auto',
          marginLeft: '20%',
          minHeight: '100%',
          paddingBottom: '113px',
          paddingTop: '45px',
          width: 100,
        }}
      >
        <Grid>
          {!hideinitialHeader && (
            <Grid item xs={12}>
              <Box
                sx={{
                  width: 350,
                }}
              >
                <Typography
                  sx={{
                    color:
                      error !== 'AccMgmt.Forgotpassword_Initialheading'
                        ? '#B11616'
                        : null,
                    fontSize: '14px',
                    fontWeight: 400,
                  }}
                >
                  {translate(error)}
                </Typography>
              </Box>
            </Grid>
          )}
          {successMessage && (
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    width: '412px',
                  }}
                >
                  {translate(
                    'AccMgmt.Forgotpassword_TemporaryPasswordSentMessage'
                  )}
                </Typography>
              </Box>
            </Grid>
          )}
          {!hideUserName && (
            <Grid item xs={6}>
              <Box sx={{ marginTop: '20px' }}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          edge="end"
                        ></IconButton>
                        <PersonOutlineOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                  error={userNameError}
                  id="Username"
                  label={translate('AccMgmt.Forgotpassword_UserName')}
                  onChange={handleChange('username')}
                  placeholder={translate('AccMgmt.Forgotpassword_UserName')}
                  required
                  size="small"
                  sx={{
                    '& .MuiInputLabel-asterisk': { color: 'error.main' },
                    '& .MuiInputLabel-root': {
                      top: '-10px',
                    },
                    '& .MuiOutlinedInput-root': {
                      marginTop: 0,
                    },
                    bgcolor: (theme) => theme.palette.common.white,
                    borderRadius: '3px',
                    marginTop: '15px',
                    width: 350,
                  }}
                  title=""
                  variant="outlined"
                />
              </Box>
            </Grid>
          )}
          {!hideEmail && (
            <Grid item xs={6}>
              <Box sx={{ marginTop: '20px' }}>
                <Tooltip
                  open={stateTooltip}
                  placement="top"
                  title={translate('AccMgmt.Forgotpassword_EmailAddressError')}
                >
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          ></IconButton>
                          <MailOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                    autoComplete="off"
                    error={emailError}
                    id="Email"
                    label={translate('AccMgmt.Forgotpassword_Email')}
                    onChange={handleChange('email')}
                    onMouseEnter={() => {
                      const isValidEmail = validEmail.test(emailAddress);
                      if (isValidEmail && emailAddress !== '') {
                        setStateTooltip(false);
                      } else if (!isValidEmail && emailAddress !== '') {
                        setStateTooltip(true);
                        setEmailError(true);
                      }
                    }}
                    onMouseLeave={() => {
                      setStateTooltip(false);
                    }}
                    placeholder={translate('AccMgmt.Forgotpassword_Email')}
                    size="small"
                    sx={{
                      '& .MuiInputLabel-asterisk': { color: 'error.main' },
                      '& .MuiInputLabel-root': {
                        top: '-10px',
                      },
                      '& .MuiOutlinedInput-root': {
                        marginTop: 0,
                      },
                      bgcolor: (theme) => theme.palette.common.white,
                      borderRadius: '3px',
                      marginTop: '15px',
                      width: 350,
                    }}
                    title=""
                    variant="outlined"
                  />
                </Tooltip>
              </Box>
            </Grid>
          )}
          {!hidesubmit && (
            <Grid item xs={6}>
              <Box sx={{ marginTop: '24px' }}>
                <Button
                  disabled={disableSubmit}
                  onClick={() => {
                    UpdateChangePassword();
                  }}
                  sx={{
                    fontSize: '14px',
                    height: 45,
                    marginBottom: '15px',
                    margintop: '15px',
                    padding: '15px',
                    position: 'inherit',
                    right: '35px',
                    width: 350,
                  }}
                  type="submit"
                  variant="contained"
                >
                  {translate('AccMgmt.Forgotpassword_Submit')}
                </Button>
              </Box>
              <Box sx={{ minWidth: '160px' }}>
                <Link to={'/login'}>
                  <Typography
                    sx={{
                      color: '#0164B0',
                      fontSize: '14px',
                    }}
                  >
                    {translate('AccMgmt.Forgotpassword_BackToLogin')}
                  </Typography>
                </Link>
              </Box>
            </Grid>
          )}
          {!hideLogin && (
            <Grid item xs={6}>
              <Box
                sx={{
                  color: '#0164B0',
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  height: '22px',
                  lineHeight: '22px',
                  marginTop: '22px',
                }}
              >
                <Button
                  onClick={() => {
                    navigate(`/login`);
                  }}
                  sx={{
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    marginBottom: '20px',
                    padding: '15px',
                    position: 'inherit',
                    right: '35px',
                    width: 350,
                  }}
                  type="submit"
                  variant="contained"
                >
                  {translate('AccMgmt.Forgotpassword_Login')}
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
};
